<template>
    <CustomHeader :text="$t('bonus.mysterybonus')" />

    <div class="bonus_container">
        <img :src="dataSet.bannerIcon" alt="">

        <div class="day_row">
            <div v-for="(item, index) in dataSet.dayList" :key="index" @click="selectTab(item)">
                <div class="day_card">
                    <img v-if="item.reward_day == dataSet.selectedTab.reward_day" src="@/assets/bonus/tab_select.png" alt="">
                    <img v-else src="@/assets/bonus/tab_default.png" alt="">
                    <div class="content">
                        <img :src="mysterioImages[index].img" alt="" width="50%">
                        <div class="date_text"
                            :style="{ color: item.reward_day == dataSet.selectedTab.reward_day ? '#FFEE00' : '' }">
                            {{ $t('common.travel') }} <span>{{ item.reward_day }}</span></div>
                        <!-- claimed -->
                        <div v-if="item.reward_data?.rewardCoin" class="select_icon"> <img
                                src="@/assets/bonus/select.png" alt="">
                        </div>
                        <!-- Expired not claimed -->
                        <div v-else-if="item.reward_data?.activeStatus === 0 && !item.reward_data?.rewardCoin"
                            class="select_icon"> <van-icon name="checked" size="18"
                                style="background: #d4d4d4; border-radius: 30px; padding:0.1px" color="red" />
                        </div>
                        <div v-else class="select_icon"> <img src="@/assets/bonus/gray_select.png" alt=""></div>
                    </div>
                </div>
                <div class="tab_arrow" v-if="item.reward_day == dataSet.selectedTab.reward_day">
                    <img src="@/assets/bonus/tab_arrow.png" alt="">
                </div>
            </div>
        </div>

    </div>
    <div style="padding: 15px 25px;">
        <div class="details_card" v-if="dataSet.selectedTab">
            <van-row class="details_content">
                <van-col span="2">
                    <img src="@/assets/bonus/smactv2_reg_time.png" alt="">
                </van-col>
                <van-col span="12" class="label_text">{{ $t('bonus.registrationTime') }}</van-col>
                <van-col span="10" class="value_text">{{ formatUnixTimestamp(dataSet.mysteryDataConfig?.config?.user_join_date)
                    }}</van-col>

                <van-col span="2">
                    <img src="@/assets/bonus/smactv2_amount.png" alt="">
                </van-col>
                <van-col span="12" class="label_text">{{ $t('bonus.totalDeposit') }} <span>{{ dataSet.selectedTab?.reward_day
                        }}</span>
                    {{ $t('common.days') }}:</van-col>
                <van-col span="10" class="value_text">R${{ formatCurrency(dataSet.selectedTab?.reward_data?.rechargeCoin || 0)
                    }}</van-col>
                <van-col span="24">
                    <van-row class="middleCard">
                        <van-col span="24" class="text_1">
                            {{ $t('bonus.claimTime') }}
                        </van-col>
                        <van-col span="24">
                            <div class="date_details">
                                <img src="@/assets/bonus/smactv2_clock.png" alt="">
                                {{ formatUnixTimestamp(dataSet.selectedTab?.reward_data?.rewardTime) }}
                            </div>
                        </van-col>
                        <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0" span="24" class="misterio_text">
                            <img src="@/assets/bonus/smactv2_misterioso.png" alt="">
                            {{ $t('bonus.mysterybonus') }}
                        </van-col>
                        <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 || dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin" span="24" class="amount">R$
                            <span :style="{ color: dataSet.selectedTab?.reward_data?.rewardCoin > 0 ? '#993900' : '' }">
                                {{ formatCurrency(dataSet.selectedTab?.reward_data?.rewardCoin || 0) }}</span></van-col>
                        <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2 ||  (dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin)" span="24" class="misterio">
                            <img src="@/assets/bonus/weikaishi_tu.png" alt="">
                        </van-col>
                    </van-row>
                </van-col>
                <!-- Expired -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && !dataSet.selectedTab?.reward_data?.rewardCoin" span="24" class="start_img"><img
                        src="@/assets/bonus/smactv2_btn_expire.png" alt=""></van-col>
                    <!-- Previous claimed -->
                 <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Today not claimed -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="start_img2"><img src="@/assets/bonus/smactv2_btn_notstart.png" alt=""
                        :class="{ 'pop-animate': dataSet.isPopping }"
                        @click="pickMisteryGift(dataSet.selectedTab?.reward_data?.activeStatus)"></van-col>

                <!-- Today claimed -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Upcoming -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2" span="24" class="statusBar"
                    style="color:#f8d8a7">
                    {{ $t('rewards.notActivated') }}
                </van-col>
            </van-row>
        </div>
    </div>
    <div class="tabel_container" v-if="dataSet.selectedTab">
        <van-row class="tabel_hed">
            <van-col span="11" class="head_alignemnet">{{ $t('bonus.depostiScope') }}</van-col>
            <van-col span="2" class="head_alignemnet">
                <div class="line"></div>
            </van-col>
            <van-col span="11" class="head_alignemnet">{{ $t('bonus.mysterybonus') }}</van-col>
        </van-row>
        <van-row class="tabel_row" v-for="(item, index) in dataSet.selectedTab?.reward_data?.reward_day_data" :key="index"
            :style="{
                backgroundColor: index % 2 === 1 ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
                borderTop: index % 2 === 1 ? '1px solid rgba(255, 255, 255, 0.15)' : 'none'
            }">
            <van-col span="12" class="head_alignemnet">R$
                <span>{{ item.recharge_min < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_min)) }} ~ {{
                    item.recharge_max < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_max)) }} </span>
            </van-col>
            <van-col span="12" class="head_alignemnet">R$
                <span style="color: #FFEE00; font-size: 14px;">{{ item.show_reward_min < 0 ? '\u221E'
                    : formatCurrency(calculateValue(item.show_reward_min))}} ~ {{ item.show_reward_max < 0 ? '\u221E' :
                            formatCurrency(calculateValue(item.show_reward_max))}} </span></van-col>
        </van-row>
    </div>
    <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
        <van-row style="padding-bottom: 10px;">
            <van-col span="6" class="">
                <div class="line1"></div>
            </van-col>
            <van-col span="12" class="title">
                <div>{{ $t('common.activityTitle') }}</div>
            </van-col>
            <van-col span="6" class="">
                <div class="line2"></div>
            </van-col>
        </van-row>
        <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
            {{ item }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { defineProps, ref, defineEmits } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';

const mysterioImages = ref(MYSTERIO_IMG)

const props = defineProps<{
    dataSet: BonusData
}>()

const emits = defineEmits(['pickMisteryGift', 'selectTab'])

const pickMisteryGift = (activeStatus: number) => {
   emits('pickMisteryGift',activeStatus)
}

const selectTab = (item: any) => {
    emits('selectTab', item)
}

</script>
<style scoped>
.bonus_container {
    padding: 40px 0 0;
    position: relative;
}

.day_row {
    padding: 0 15px;
    position: absolute;
    bottom: 25px;
    display: flex;
    flex-direction: row;
}

.bonus_container img {
    width: 100%;
}

.day_card {
    position: relative;
    margin: 0 2.5px;
}

.day_card img {
    width: 100%;

}

.content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* background: red; */
}

.logo img {
    width: 60px;
}

.date_text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.45);
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: -10px;
}

.date_text span {
    font-size: 20px;
    padding-left: 5px;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding-top: 10px;
}

.details_card {
    margin-top: -30px;
    position: relative;
    background-color: #3e2c23;
    border-radius: 15px;
    border-bottom: 3px solid #dd7a33;
    border-top: 3px solid #dd7a33;
    padding: 5px 0 15px;
}

.details_card img {
    width: 100%;
}

.tab_arrow {
    display: flex;
    justify-content: center;
}

.tab_arrow img {
    width: 25px;
}

.details_content {
    padding: 0 25px;
}

.details_content img {
    width: 20px;
    padding: 5px 0;
}

.label_text {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.65);
    font-size: 3.3vw;
}

.label_text span {
    color: #FFEE00;
    padding: 0 5px;
}

.value_text {
    display: flex;
    align-items: center;
    justify-content: right;
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
}

.text_1 {
    color: rgba(0, 0, 0, 0.65);
    font-size: 13px;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 0px 35px 10px;
}

.middleCard {
    border-radius: 15px;
    padding: 20px;
    background-image: linear-gradient(0deg, #c89669 0%, rgba(255, 237, 194, 1) 100%);
}

.date_details {
    color: #000000;
    font-weight: bold;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.date_details img {
    width: 20px;
    padding: 5px;
}

.misterio_text {
    color: rgba(0, 0, 0, 0.65);
    font-weight: bold;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.misterio_text img {
    width: 20px;
    padding: 5px;
}

.amount {
    color: rgba(0, 0, 0, 0.65);
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.amount span {
    font-size: 6vw;
    padding: 0 5px;
    color: rgba(0, 0, 0, 0.25);
    font-weight: bold;

}

.start_img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img img {
    width: 310px;
}

.start_img2 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img2 img {
    width: 310px;
}

.misterio {
    display: flex;
    align-items: center;
    justify-content: center;
}

.misterio img {
    width: 40%;
}

.tabel_container {
    border: 2px solid rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    margin: 0 25px;
}

.tabel_hed {
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.85);
    font-weight: bold;
    padding: 8px;
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.line {
    width: 1px;
    height: 15px;
    background-color: rgba(255, 255, 255, 0.15);
}

.tabel_row {
    color: rgba(255, 255, 255, 0.45);
    padding: 5px;
    font-size: 13px;
}

.tabel_row span {
    font-weight: bold;
    color: rgba(255, 255, 255, 0.85);
    padding: 0 5px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

.statusBar {
    display: flex;
    justify-content: center;
    align-items: center;
    color: green;
    font-weight: bold;
    font-size: 16px;
    background: #0000003b;
    padding: 15px;
    border-radius: 10px;
    margin: 15px 0 10px;

}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@media(min-width: 400px) {
    .label_text {
        font-size: 13px !important;
    }

    .amount span {
        font-size: 30px !important;
    }
}
</style>